import React from 'react'

export default function Third() {
return (
<>
    <section className="section benefit-section bg-light-300">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6 wow fadeInUp text-center" data-wow-delay="0.2s">
                    <div className="section-header text-center">
                        <h2 className="mb-2">Our Benefits & Key
                            Advantages</h2>
                        <p className="sub-title">At Cornleth, we specialize in curating unforgettable journeys to the most sought-after destinations. Enjoy exclusive benefits, personalized service, and seamless travel experiences designed for the discerning traveler.</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-sm-6 col-lg-3 d-flex">
                    <div className="card benefit-card flex-fill wow fadeInUp mb-0" data-wow-delay="0.2s">
                        <div className="card-body text-center">
                            <div className="benefit-icon bg-secondary text-gray-9 mx-auto mb-2">
                                <i className="isax isax-lock-1"></i>
                            </div>
                            <h5 className="mb-2">Effortless Booking</h5>
                            <p className="mb-0">Access powerful tools to track performance and make data-driven decisions.</p>
                            <span className="icon-view text-secondary"><i className="isax isax-lock-1"></i></span>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-3 d-flex">
                    <div className="card benefit-card flex-fill wow fadeInUp mb-0" data-wow-delay="0.2s">
                        <div className="card-body text-center">
                            <div className="benefit-icon bg-orange mx-auto mb-2 text-white">
                                <i className="isax isax-magicpen"></i>
                            </div>
                            <h5 className="mb-2">Enhanced Reporting</h5>
                            <p className="mb-0">A centralized place to buy tickets for various dates of the tour</p>
                            <span className="icon-view text-orange"><i className="isax isax-magicpen"></i></span>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-3 d-flex">
                    <div className="card benefit-card flex-fill wow fadeInUp mb-0" data-wow-delay="0.2s">
                        <div className="card-body text-center">
                            <div className="benefit-icon bg-purple mx-auto mb-2 text-white">
                                <i className="isax isax-receipt-add"></i>
                            </div>
                            <h5 className="mb-2">Flexible Solutions</h5>
                            <p className="mb-0">Our system supports both B2B and B2C operations seamlessly.</p>
                            <span className="icon-view text-purple"><i className="isax isax-receipt-add"></i></span>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-lg-3 d-flex">
                    <div className="card benefit-card flex-fill wow fadeInUp mb-0" data-wow-delay="0.2s">
                        <div className="card-body text-center">
                            <div className="benefit-icon bg-teal mx-auto mb-2 text-white">
                                <i className="isax isax-location-tick"></i>
                            </div>
                            <h5 className="mb-2">User-Friendly</h5>
                            <p className="mb-0">Enjoy a platform designed for simplicity and efficiency at every step.</p>
                            <span className="icon-view text-teal"><i className="isax isax-location-tick"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</>
)
}
